import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import dynamicTranslation from '../../../../utils/translation/DynamicTranslationService';
import withImpressions from '../../hoc/withImpressions';
import { TEXT } from '../../../../constants';
import styles from './styles.module.scss';

const INDUSTRIES_SEPARATOR = ', ';
const IMPRESSION_COMPONENT_CLASS = 'industry-wrapper';

const impressionConfig = {
    DOMSelector: `.${IMPRESSION_COMPONENT_CLASS}`,
    getImpressionData: (data, { reviewerIndustry, position }) => ({
        type: 'review_industry_is_shown',
        page: {
            element: {
                name: 'buyer_review',
                type: TEXT,
                text: reviewerIndustry.join(),
                metadata: "Buyer's Industry",
                position,
            },
            component: {
                name: 'gig_review',
            },
        },
    }),
};

const Industry = ({ reviewerIndustry }) => (
    <span className={classNames(styles.industryWrapper, 'tbody-6')}>
        <Text color="bodySecondary" size="b_xs">
            <I18n k="reviews.industry" params={{ count: reviewerIndustry.length }} />:
        </Text>
        <Text color="bodySecondary" size="b_xs">
            {reviewerIndustry
                .map((industry) => dynamicTranslation.getIndustryTranslation(industry))
                .join(INDUSTRIES_SEPARATOR)}
        </Text>
    </span>
);

export default withImpressions(Industry, impressionConfig);
